document.addEventListener('DOMContentLoaded', () => {
  const layout = document.querySelector('.form-selector-layout');
  if (!layout) return;

  const csvUrl = layout.dataset.vehicleList;
  const redirectType = layout.dataset.redirectType || 'pages';
  const redirectHandle = layout.dataset.handle || '';
  const desktopContainer = document.querySelector('.vehicle-selector-bar__form.desktop-only');
  const mobileContainer = document.querySelector('.mobile-popup-content');
  const popupTrigger = document.querySelector('.vehicle-popup-trigger');
  const popupOverlay = document.querySelector('.vehicle-popup-overlay');
  const popupClose = document.querySelector('.vehicle-popup-close');

  // ✅ Create the dropdown form HTML template
  const createForm = () => `
    <div class="dropdown-wrapper">
      <select class="yearSelect custom-dropdown">
        <option value="">Select Year</option>
      </select>
    </div>
    <div class="dropdown-wrapper">
      <select class="makeSelect custom-dropdown" disabled>
        <option value="">Select Make</option>
      </select>
    </div>
    <div class="dropdown-wrapper">
      <select class="modelSelect custom-dropdown" disabled>
        <option value="">Select Model</option>
      </select>
    </div>
    <div class="button-wrapper">
      <button disabled class="vehicleSearchBtn vehicle-btn shop-btn" style="color:#fff;">Search</button>
    </div>
  `;

  desktopContainer.innerHTML = createForm();
  mobileContainer.innerHTML = createForm();

  // Utility to get dropdowns within any container
  const getElements = (container) => ({
    year: container.querySelector('.yearSelect'),
    make: container.querySelector('.makeSelect'),
    model: container.querySelector('.modelSelect'),
    search: container.querySelector('.vehicleSearchBtn')
  });

  const desktop = getElements(desktopContainer);
  const mobile = getElements(mobileContainer);

  // CSV parser
  const parseCSV = (text) => {
    text = text.replace(/^\uFEFF/, '').trim();
    const lines = text.split(/\r?\n/).filter(l => l.trim().length);
    const sample = lines[0];
    let delimiter = ',';
    if (sample.split('\t').length > sample.split(',').length) delimiter = '\t';
    else if (sample.split(';').length > sample.split(',').length) delimiter = ';';
    return lines.map(line => line.split(delimiter).map(c => c.trim().replace(/^"|"$/g, '')));
  };

  fetch(csvUrl)
    .then(res => res.text())
    .then(text => {
      const rows = parseCSV(text);
      const header = rows.shift().map(h => h.toLowerCase());
      const yearIndex = header.indexOf('year');
      const makeIndex = header.indexOf('make');
      const modelIndex = header.indexOf('model');

      if (yearIndex === -1 || makeIndex === -1 || modelIndex === -1) {
        console.error('CSV missing required columns: Year, Make, or Model');
        return;
      }

      // Create nested structure year → make → models[]
      const data = {};
      const years = new Set();

      rows.forEach(r => {
        const year = r[yearIndex]?.trim();
        const make = r[makeIndex]?.trim();
        const model = r[modelIndex]?.trim();
        if (!year || !make || !model) return;
        years.add(year);
        if (!data[year]) data[year] = {};
        if (!data[year][make]) data[year][make] = [];
        if (!data[year][make].includes(model)) data[year][make].push(model);
      });

      // Helper to populate Years
      const populateYears = (elements) => {
        [...years].sort((a, b) => Number(b) - Number(a)).forEach(year => {
          const opt = document.createElement('option');
          opt.value = year;
          opt.textContent = year;
          elements.year.appendChild(opt);
        });
      };

      // Get all makes (across all years)
      const allMakes = [...new Set(
        Object.values(data).flatMap(yearData => Object.keys(yearData))
      )].sort();

      // Populate makes
      const populateMakes = (elements) => {
        elements.make.innerHTML = '<option value="">Select Make</option>';
        allMakes.forEach(make => {
          const opt = document.createElement('option');
          opt.value = make;
          opt.textContent = make;
          elements.make.appendChild(opt);
        });
      };

      // Shared dropdown logic
      const setupFilterLogic = (elements) => {
        const { year, make, model, search } = elements;

        // Populate Years
        populateYears(elements);

        // Initially disable make & model
        make.disabled = true;
        model.disabled = true;
        search.disabled = true;

        // When year is selected — enable make dropdown
        year.addEventListener('change', () => {
          model.innerHTML = '<option value="">Select Model</option>';
          make.innerHTML = '<option value="">Select Make</option>';
          search.disabled = true;
          model.disabled = true;

          if (year.value) {
            populateMakes(elements);
            make.disabled = false;
          } else {
            make.disabled = true;
          }
        });

        make.addEventListener('change', () => {
          const selectedMake = make.value;
          model.innerHTML = '<option value="">Select Model</option>';
          model.disabled = true;
          search.disabled = true;

          // Collect all models across all years for this make
          const allModels = new Set();
          Object.values(data).forEach(yearData => {
            if (yearData[selectedMake]) {
              yearData[selectedMake].forEach(m => allModels.add(m));
            }
          });

          if (allModels.size > 0) {
            [...allModels].sort().forEach(md => {
              const opt = document.createElement('option');
              opt.value = md;
              opt.textContent = md;
              model.appendChild(opt);
            });
            model.disabled = false;
          }
        });

        model.addEventListener('change', () => {
          search.disabled = !model.value;
        });

        search.addEventListener('click', () => {
          const y = year.value;
          const m = make.value;
          const mo = model.value;
          if (!m || !mo) return alert('Please select Make and Model');

          const query = new URLSearchParams({ year: y, make: m, model: mo }).toString();
          if (redirectHandle) {
            window.location.href = `/${redirectType}/${redirectHandle}?${query}`;
          } else {
            alert('Redirect handle missing in section settings');
          }
        });
      };

      // Initialize for both desktop and mobile
      setupFilterLogic(desktop);
      setupFilterLogic(mobile);
    })
    .catch(err => console.error('Error loading CSV:', err));

  // Popup logic
  if (popupTrigger && popupOverlay && popupClose) {
    popupTrigger.addEventListener('click', () => {
      popupOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    popupClose.addEventListener('click', () => {
      popupOverlay.classList.remove('active');
      document.body.style.overflow = '';
    });

    popupOverlay.addEventListener('click', (e) => {
      if (e.target === popupOverlay) {
        popupOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }
});
